import { render, staticRenderFns } from "./HomeCustomizations.vue?vue&type=template&id=2ed7a561&"
import script from "./HomeCustomizations.vue?vue&type=script&lang=js&"
export * from "./HomeCustomizations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports